module.exports = __webpack_public_path__ + "assets/img/budapark3-1280.f9e6ca92.webp";